<template>
  <div class="w-75">
    <b-row>
      <FITSearchableTable>
      </FITSearchableTable>
    </b-row>
  </div>
</template>
<script>
import { FITSearchableTable } from '@/components'
export default {
  name: 'QuickRenewal',
  created() {
    console.debug('wqe')
  },
  components: { FITSearchableTable }
}

</script>



// WEBPACK FOOTER //
// src/Quick/containers/QuickRenewal.vue